module.exports = __webpack_public_path__ + "img/history2017.3ad75d16.jpg";